import { betkoPopupWithAction } from '../../utils/BetkoPopupModal'
import { areAllFieldsFilled } from '../../utils/calculationDataValidation'
import runCalculator from '../api/runCalculator'
import classesK from '../kalkulatori.module.css'
import InfoBar from '../redesign/components/InfoBar'
import OddsCalculator from '../redesign/components/OddsCalculator'
import ResultsSection from '../redesign/components/ResultsSection'
import classes from './stoniTenis.module.css'
import { useEffect, useState } from 'react'

const SLUG_BY_TYPE = {
  'Stoni tenis': 'table-tennis',
  Badminton: 'badminton',
  Bilijar: 'snooker',
  Esports: 'esports',
  Odbojka: 'volleyball',
  'Odbojka na pesku': 'beach-volleyball',
  Pikado: 'darts',
}

const StoniTenis = ({ calculatorType = 'Stoni tenis' }) => {
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const [data, setData] = useState({
    values: {
      odds: ['', ''],
      sets: [''],
      setsBoth: ['', '', '', '', '', ''],
    },
    results: {
      oddsPercentages: ['', ''],
      sets: ['', '', '', ''],
      score: ['', ''],
      teamStrengths: ['', '', '', '', '', '', '', ''],
    },
  })

  const allInputsFilled = areAllFieldsFilled(data.values)

  useEffect(() => {
    if (allInputsFilled) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [allInputsFilled])

  const clearFields = () => {
    setData({
      values: {
        odds: ['', ''],
        sets: [''],
        setsBoth: ['', '', '', '', '', ''],
      },
      results: {
        oddsPercentages: ['', ''],
        sets: ['', '', '', ''],
        score: ['', ''],
        teamStrengths: ['', '', '', '', '', '', '', ''],
      },
    })
    setShowInputArea(true)
  }

  const buildBody = () => {
    const odds = data?.values?.odds || ['', '']
    const sets = data?.values?.sets || ['']
    const setsBoth = data?.values?.setsBoth || ['', '', '', '', '', '']

    const [odd1Str, odd2Str] = odds
    const [setsToWinStr] = sets
    const [wins1Str, losses1Str, played1Str, wins2Str, losses2Str, played2Str] =
      setsBoth

    return {
      oddsPlayer1: parseFloat(odd1Str),
      oddsPlayer2: parseFloat(odd2Str),
      setsToWinMatch: parseFloat(setsToWinStr),
      player1SetsWon: parseFloat(wins1Str),
      player1SetsLost: parseFloat(losses1Str),
      player1MatchesPlayed: parseFloat(played1Str),
      player2SetsWon: parseFloat(wins2Str),
      player2SetsLost: parseFloat(losses2Str),
      player2MatchesPlayed: parseFloat(played2Str),
    }
  }

  const calculateTenisStats = async () => {
    const slug = SLUG_BY_TYPE[calculatorType] || 'table-tennis'
    setLoading(true)
    setError(false)
    try {
      const res = await runCalculator('predictions', slug, buildBody())

      const minSets = Math.floor(res.setsToWinMatch)
      const maxSets = res.maxSets
      const midSets = Math.floor((minSets + maxSets) / 2)
      const suggestedBetString = `${parseFloat(res.suggestion).toFixed(1)} +`

      setData((prev) => ({
        ...prev,
        results: {
          oddsPercentages: [
            res.player1WinPct.toFixed(2),
            res.player2WinPct.toFixed(2),
          ],
          sets: [minSets, midSets, maxSets, suggestedBetString],
          score: [res.player1ExpectedSets, res.player2ExpectedSets],
          teamStrengths: [
            res.homeGoalsScoredAvg.toFixed(2), // SND
            res.homeGoalsConcededAvg.toFixed(2), // SOD
            res.awayGoalsConcededAvg.toFixed(2), // SNG
            res.awayGoalsScoredAvg.toFixed(2), // SOG
            res.homeScoredAwayConcededAvg.toFixed(2), // SNDG
            res.homeConcededAwayScoredAvg.toFixed(2), // SODG
            res.homeAwayScoredAvg.toFixed(2), // SNDSOG
            res.homeAwayConcededAvg.toFixed(2),
          ],
        },
      }))
      return true
    } catch (err) {
      setError(true)
      return false
    } finally {
      setLoading(false)
    }
  }

  const [showInputArea, setShowInputArea] = useState(true)
  const toggleInputArea = async () => {
    if (!showInputArea) {
      clearFields()
      return
    }
    const ok = await calculateTenisStats()
    if (ok) {
      setShowInputArea(false)
    }
  }

  useEffect(() => {
    if (error) {
      betkoPopupWithAction(
        'Greška',
        'Greška pri obračunu, pokušajte ponovo.'
      )
    }
  }, [error])

  console.log('data', data)

  return (
    <div className={classesK.container}>
      <InfoBar calculatorType={calculatorType} onRefresh={clearFields} />
      <div className={classesK.contentContainer}>
        <div className={classesK.submitWrapper}>
          <span>Unesi nove obračunske podatke</span>
          <button onClick={toggleInputArea} disabled={disabled || loading}>
            {loading
              ? 'Obračunavam...'
              : showInputArea
              ? 'Prikaži rezultate'
              : 'Unesi obračunske podatke'}
          </button>
        </div>
        {showInputArea && (
          <>
            <div className={classes.sectionContainer}>
              <div className={classesK.sectionTitle}>
                Upiši kvote za ishod meča
              </div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'odds'}
                labelPrefix={['KI 1', 'KI 2']}
                step={['0.1', '0.1']}
                min={['0.1', '0.1']}
                type={['number', 'number']}
                setError={setError}
                rows={2}
              />
              <div className={classesK.sectionTitle}>
                Meč na broj dobijenih setova
              </div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'sets'}
                labelPrefix={['Br. dobijenih setova na koliko se igra meč']}
                step={['1']}
                min={['1']}
                type={['number']}
                setError={setError}
                rows={1}
              />
              <div className={classesK.sectionTitle}>
                Upiši br. Setova / br. ut. za oba tima
              </div>
              <OddsCalculator
                data={data.values}
                setData={setData}
                field={'setsBoth'}
                labelPrefix={[
                  'TIM / IGRAČ 1 +  (pobedio setova)',
                  'TIM / IGRAČ 1 - (izgubio setova)',
                  'TIM / IGRAČ 1 (odigrao br. mečeva)',
                  'TIM / IGRAČ 2 +  (pobedio setova)',
                  'TIM / IGRAČ 2-  (izgubio setova)',
                  'TIM / IGRAČ 2 (odigrao br. mečeva)',
                ]}
                step={['1', '1', '1', '1', '1', '1']}
                min={['0', '0', '1', '0', '0', '1']}
                type={[
                  'number',
                  'number',
                  'number',
                  'number',
                  'number',
                  'number',
                ]}
                setError={setError}
                rows={3}
              />
            </div>
          </>
        )}

        {!showInputArea && (
          <div className={classes.sectionResults}>
            <ResultsSection
              title={'Ishod meča'}
              subtitle={'Konačan ishod'}
              results={data?.results?.oddsPercentages.map(
                (result) => `${result}%`
              )}
              names={['KI 1', 'KI 2']}
              withPercent={true}
            />
            <ResultsSection
              title={'Setovi'}
              subtitle={'Predikcije setova'}
              results={data?.results?.sets}
              names={[
                'Predikcija minimalnog br. setova na meču',
                'Predikcija srednjeg br. setova na meču',
                'Predikcija maksimalnog broja setova na meču',
                'Betko predlog za broj setova na meču ( + )',
              ]}
              rows={2}
            />
            <ResultsSection
              title={'Tačan rezultat u setovima'}
              subtitle={'Predikcije osvojenih setova'}
              results={data?.results?.score}
              names={[
                'Očekivani broj osvojenih setova Tim/Igrač 1',
                'Očekivani broj osvojenih setova Tim/Igrač 2',
              ]}
            />
            <ResultsSection
              title={'Snage timova'}
              subtitle={'Snaga domaćina'}
              results={[
                data?.results?.teamStrengths[0],
                data.results?.teamStrengths[1],
              ]}
              names={['SND ( snaga napada )', 'SOD ( snaga odbrane )']}
            />
            <ResultsSection
              subtitle={'Snaga gosta'}
              results={[
                data?.results?.teamStrengths[2],
                data.results?.teamStrengths[3],
              ]}
              names={['SNG ( snaga napada )', 'SOG ( snaga odbrane )']}
            />
            <ResultsSection
              subtitle={'Snage oba tima zajedno'}
              results={[
                data?.results?.teamStrengths[4],
                data.results?.teamStrengths[5],
              ]}
              names={[
                'SNDG ( snaga napada domaćina i gosta )',
                'SODG ( snaga odbrane domaćina i gosta )',
              ]}
            />
            <ResultsSection
              subtitle={'Tim proseci odbrana i napada'}
              results={[
                data?.results?.teamStrengths[6],
                data.results?.teamStrengths[7],
              ]}
              names={[
                'SND+SOG ( snaga napada domaćin + snaga odbrane gost )',
                'SOD+SNG ( snaga napada domaćin + snaga odbrane gost )',
              ]}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default StoniTenis
